var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.loading
        ? _c("rb-loader-glasses")
        : _c(
            "div",
            { staticClass: "wishlist__items" },
            [
              _vm.isEmpty
                ? _c(
                    "div",
                    { staticClass: "rb-sidebar-content__top-section-empty" },
                    [
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.translation(
                              "common.sidebar_miniwishlist_empty_no_items"
                            )
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.translation(
                              "common.sidebar_miniwishlist_empty_discover"
                            )
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          attrs: {
                            href: _vm.linkSunglasses,
                            "data-element-id":
                              "X_X_MainNav_Account_ViewSunglasses",
                          },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.translation(
                                  "common.sidebar_miniwishlist_empty_view_glasses"
                                )
                              ) +
                              "\n      "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          attrs: {
                            href: _vm.linkOptics,
                            "data-element-id":
                              "X_X_MainNav_Account_ViewEyeglasses",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.translation(
                                "common.sidebar_miniwishlist_empty_view_optics"
                              )
                            )
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("hr"),
                    ]
                  )
                : _vm._l(_vm.items, function (item) {
                    return _c(
                      "div",
                      { key: item.catentryId, staticClass: "wishlist__item" },
                      [
                        item.name
                          ? _c("p", { staticClass: "item__name" }, [
                              _vm._v(
                                "\n          " +
                                  _vm._s(item.name) +
                                  "\n        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "grid grid--gap-2" }, [
                          _c(
                            "div",
                            { staticClass: "item__left-column col-6" },
                            [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: item.pdpURL,
                                    "data-description":
                                      item.name + "_" + item.partnumber,
                                    "data-element-id":
                                      "X_X_MainNav_Account_Tiles",
                                  },
                                },
                                [
                                  _c("img", {
                                    staticClass: "item__image",
                                    attrs: {
                                      src: item.image,
                                      alt: item.displaySKU,
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "item__info col-6" },
                            [
                              !item.isRemix
                                ? [
                                    item.price &&
                                    item.price.list === item.price.offer
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "rb-sidebar-content__price",
                                          },
                                          [
                                            _c("format-price", {
                                              attrs: {
                                                value: Number(
                                                  _vm.getPriceFromItem(item)
                                                ),
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.price &&
                                    item.price.list !== item.price.offer
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "rb-sidebar-content__price",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "rb-pdp-sticky-bar__price__original",
                                              },
                                              [
                                                _c("format-price", {
                                                  attrs: {
                                                    value: Number(
                                                      item.price.list
                                                    ),
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "rb-pdp-sticky-bar__price__discounted",
                                              },
                                              [
                                                _c("format-price", {
                                                  attrs: {
                                                    value: Number(
                                                      item.price.offer
                                                    ),
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                : [
                                    item.discountPrice &&
                                    item.discountPrice !== item.price
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "rb-sidebar-content__price",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "rb-pdp-sticky-bar__price__original",
                                              },
                                              [
                                                _c("format-price", {
                                                  attrs: {
                                                    value: Number(item.price),
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "rb-pdp-sticky-bar__price__discounted",
                                              },
                                              [
                                                _c("format-price", {
                                                  attrs: {
                                                    value: Number(
                                                      item.discountPrice
                                                    ),
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticClass:
                                              "rb-sidebar-content__price",
                                          },
                                          [
                                            _c("format-price", {
                                              attrs: {
                                                value: Number(item.price),
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                  ],
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "rb-btn rb-btn--underlined rb-btn__remove",
                                  attrs: {
                                    "data-element-id":
                                      "X_X_MainNav_Account_Remove",
                                    "data-description":
                                      item.name + "_" + item.partnumber,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeFromWishlist(item)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.translation("common.sidebar_remove")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              item.addToBagFlag
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "rb-btn rb-btn--red rb-btn__add-to-bag",
                                      attrs: {
                                        "data-element-id":
                                          "X_X_MainNav_Account_AddCart",
                                        "data-description":
                                          item.name + "_" + item.partnumber,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.addToBag(item)
                                        },
                                      },
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.translation(
                                              "common.sidebar_miniwishlist_addto_bag"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]),
                      ]
                    )
                  }),
            ],
            2
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }